import { trackEvent } from '~/utils/tracking'

export const signUpClickEvent = () => {
  trackEvent('click_sign_up')
}

export const loginClickEvent = () => {
  trackEvent('click_log_in')
}

export const careerAdviceEventHandle = () => {
  trackEvent('click_career_advice')
}

export const handleVisitedFooter = () => {
  trackEvent('show_footer')
}
